import React, { Component } from "react";
import { connect } from "react-redux";

import "./Tour.css";
import { HOME, PROJECT_HOME } from "App/Routes";
import TourPage from "./TourPage";

import { setProject } from "actions";
import { GET_TOPICS } from "services/api";
import Router from "router";
import getApiGenerator from "services/getApiGenerator";
import sessionStorageService from "services/sessionStorageService";

export const mapStateToProps = (state, ownProps) => {
  return {
    projectId: state.projectId,
    language: state.language
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setProject: project => {
      dispatch(setProject(project));
    }
  };
};

export class TourContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectUrl: props.projectId
        ? PROJECT_HOME.format(props.projectId)
        : HOME,
      completedTour: false,
      slidesLength: null
    };

    this.setSlidesLength = this.setSlidesLength.bind(this);
    this.setCompletedTour = this.setCompletedTour.bind(this);
  }

  componentDidMount() {
    // loads loginRedirectUrl from sessionStorage (if available)
    // eventually loginRedirectUrl will be dumped when new page is loaded
    // (not REGISTER nor LOGIN nor RESET_PASSWORD)
    // for the aforementioned dumping, see SingleProjectApp.js
    let loginRedirectUrl = sessionStorageService.getItem("loginRedirectUrl");

    if (loginRedirectUrl) {
      this.setState({ redirectUrl: loginRedirectUrl });
    }

    if (this.props.projectId) {
      this.getProject();
    }
  }

  componentDidUpdate(prevProps) {
    let loginRedirectUrl = sessionStorageService.getItem("loginRedirectUrl");

    if (
      !loginRedirectUrl &&
      this.props.projectId &&
      this.props.projectId !== prevProps.projectId
    ) {
      this.setState({ redirectUrl: PROJECT_HOME.format(this.props.projectId) });
    } else if (!loginRedirectUrl && !this.props.projectId) {
      this.setState({ redirectUrl: HOME });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      (typeof this.state.slidesLength !== "number" &&
        this.state.slidesLength !== nextState.slidesLength &&
        nextState.slidesLength > 0) ||
      this.state.completedTour !== nextState.completedTour
    );
  }

  getProject() {
    getApiGenerator(
      GET_TOPICS.format(this.props.projectId),
      {
        page: 1
      },
      this.props.sessionKey
    ).end((err, res) => {
      /* API success */
      if (!(err || res.body.code !== 200)) {
        this.props.setProject(res.body.game);
      }
    });
  }

  handleCloseClick = e => {
    e.preventDefault();

    Router.replaceAndNavigate(this.state.redirectUrl);
  };

  setSlidesLength(slidesLength) {
    this.setState({ slidesLength: slidesLength });
  }

  setCompletedTour() {
    this.setState({ completedTour: true });
  }

  render() {
    return (
      <TourPage
        projectId={this.props.projectId}
        redirectUrl={this.state.redirectUrl}
        completedTour={this.state.completedTour}
        slidesLength={this.state.slidesLength}
        handleCloseClick={this.handleCloseClick}
        setSlidesLength={this.setSlidesLength}
        setCompletedTour={this.setCompletedTour}
        language={this.props.language}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TourContainer);
